module.exports = __webpack_public_path__ + "static/sample-a2f26760a144096ca82ca9398886eb2f.mp4";